import type { AntonioError, RequestResult } from '@ackee/antonio-core';

import { createApiRequest, type FetcherOptions, type FetcherProps } from './createApiRequest';

export type ErrorType<Error> = AntonioError<Error>;

// In case you want to wrap the body type (optional)
export type BodyType<BodyData> = BodyData;

export const fetcher = async <T>(props: FetcherProps, options?: FetcherOptions): Promise<RequestResult<T>> =>
    createApiRequest<T>(props, options);
